// src/data/jobs/jobsData.ua.ts

export const jobsDataUA = [
  {
    question: "Менеджер з продажу",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>Ми — динамічна компанія, що активно розвивається та постійно розширює клієнтську базу. У зв'язку зі зростанням бізнесу шукаємо менеджера з продажу, який працюватиме з нашими існуючими клієнтами та допоможе нам досягти нових висот!</p>
<p><strong>Що ми пропонуємо:</strong></p>
<ul>
<li>Конкурентна зарплата: 3000 € (плюс бонуси за досягнення цілей).</li>
<li>Кар'єрні можливості: ваш успіх у продажах відкриває нові можливості для розвитку в компанії.</li>
<li>Робота в команді професіоналів: амбітна атмосфера та колектив, орієнтований на спільні досягнення.</li>
<li>Комфортний офіс із сучасними зручностями для продуктивної роботи.</li>
<li>Додаткові бонуси та заохочення: ми цінуємо ваші зусилля та завжди готові винагороджувати хороші результати!</li>
</ul>
<p><strong>Ваші обов'язки:</strong></p>
<ul>
<li>Робота з постійними клієнтами: побудова довгострокових відносин та збільшення обсягів продажів.</li>
<li>Проведення переговорів та укладання нових контрактів.</li>
<li>Презентація продуктів та послуг: демонстрація цінності наших рішень для клієнтів.</li>
</ul>
<p><strong>Що ми очікуємо від вас:</strong></p>
<ul>
<li>Досвід роботи в продажах.</li>
<li>Вміння будувати довірливі відносини з клієнтами та успішно вести переговори.</li>
<li>Орієнтація на результат та здатність досягати поставлених цілей.</li>
<li>Відмінні комунікативні навички та наполегливість.</li>
<li>Вільне володіння німецькою мовою (усно та письмово) – обов'язкова умова для роботи з клієнтами та партнерами.</li>
<li>Бажання особистого та професійного розвитку в галузі продажів.</li>
</ul>
</div>`,
    description: "Офіс у районі Панков, Берлін.",
  },
  {
    question: "Автомеханік",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>Компанія HIXA GmbH запрошує досвідчених автомеханіків стати частиною нашої сучасної та динамічної команди автосервісу!</p>
<p><strong>Чому варто працювати у нас?</strong></p>
<ul>
<li>Конкурентна зарплата + бонуси за відмінні результати!</li>
<li>Офіційне працевлаштування та повний соціальний пакет – ми дбаємо про наших працівників.</li>
<li>Дружня команда та комфортні умови праці – робота в атмосфері взаємної підтримки та професіоналізму.</li>
</ul>
<p><strong>Кого ми шукаємо:</strong></p>
<ul>
<li>Досвідчених автомеханіків з досвідом ремонту легкових автомобілів.</li>
<li>Знання основних автомобільних систем та вміння працювати з сучасним діагностичним обладнанням.</li>
<li>Здатність працювати в команді та бажання розвиватися у своїй професії.</li>
</ul>
<p><strong>Ваші обов'язки:</strong></p>
<ul>
<li>Ремонт коробок передач (включаючи DSG) на легкових автомобілях.</li>
<li>Діагностика несправностей за допомогою сучасного обладнання.</li>
<li>Технічне обслуговування та ремонт автомобілів, а також заміна деталей.</li>
</ul>
<p><strong>Що ми пропонуємо:</strong></p>
<ul>
<li>Ми цінуємо професіоналізм та надаємо реальні можливості для кар'єри та розвитку.</li>
<li>Очікуємо якісну роботу та готові справедливо винагороджувати ваші зусилля.</li>
<li>Підтримуємо тих, хто хоче рости та розвиватися, пропонуючи чудові умови для професіоналів.</li>
</ul>
</div>`,
    description: "Майстерня у районі Панков, Берлін",
  },
  {
    question: "Механік з ремонту мехатроніки (DSG, S-tronic, PowerShift)",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>HIXA GmbH — це сучасний центр автосервісу, що спеціалізується на демонтажі/монтажі, відновленні та програмуванні мехатронних блоків. Ми пишаємося високою якістю наших послуг та професіоналізмом нашої команди. Працюємо згідно з вимогами виробників, прагнемо до найкращих результатів та фокусуємося на вимірюваних досягненнях.</p>
<p><strong>Шукаємо:</strong></p>
<ul>
<li>Досвідченого механіка з ремонту мехатронних блоків (DSG, S-tronic, PowerShift) – діагностика, демонтаж/монтаж на автомобілі, відновлення гідравлічних блоків та програмування/кодування блоків керування коробкою передач.</li>
</ul>
<p><strong>Ваші обов'язки:</strong></p>
<ul>
<li>Діагностика несправностей мехатроніки (гідравліка/електроніка) та систематичний пошук помилок.</li>
<li>Демонтаж та монтаж мехатроніки на автомобілі, включаючи необхідну заміну мастила згідно з вимогами.</li>
<li>Відновлення, перевірка герметичності та функціональності гідравлічних блоків.</li>
<li>Програмування та кодування блоків керування коробкою передач (ODIS/VCDS).</li>
<li>Контроль якості, документування та передача автомобіля клієнту.</li>
</ul>
<p><strong>Ми пропонуємо:</strong></p>
<ul>
<li>Конкурентну зарплату (фіксована частина + премії).</li>
<li>Сучасні діагностичні пости, спеціалізовані інструменти та стенди для мехатроніки.</li>
<li>Підвищення кваліфікації та розвиток у стабільній компанії.</li>
<li>Приємні умови праці та дружня, професійна команда.</li>
</ul>
<p><strong>Вимоги:</strong></p>
<ul>
<li>Практичний досвід ремонту мехатроніки DSG, S-tronic або PowerShift.</li>
<li>Глибокі знання гідравліки та основ автомобільної електроніки.</li>
<li>Впевнене володіння діагностичними системами (ODIS, VCDS).</li>
<li>Акуратність, відповідальність та високі вимоги до якості власної роботи.</li>
</ul>
</div>`,
    description: "Майстерня у районі Панков, Берлін",
  },
];
